import { RareMobEventSchema } from '@shefira/shared';

import { cue } from '../audio/cues.js';

/** The little of a Colyseus room this needs. */
interface RareRoom {
  onMessage: (type: string, callback: (payload: unknown) => void) => unknown;
}

/**
 * A wandering rare (ADR 0094) has stood up in the player's region: the
 * server says so with the rumour, to that region only, and the client rings
 * its call. Where it stands is never told; the chat already reads the rumour.
 */
export function listenRareMobs(room: RareRoom): void {
  room.onMessage('rare_mob', (payload: unknown) => {
    const parsed = RareMobEventSchema.safeParse(payload);
    if (parsed.success && parsed.data.phase === 'appeared') cue('sfx.rare-call');
  });
}
